// extracted by mini-css-extract-plugin
module.exports = {"page":"page-2L6GX","container":"container-1aX2v","printArea":"printArea-1PXFH"};